import React from 'react';
import { Link } from 'react-router-dom';
import whiteLogo from '../../Assets/logo/white.png';
import coloredLogo from '../../Assets/logo/colored.png';

/**
 * A reusable Logo component that can be used throughout the application
 * 
 * @param {Object} props - Component props
 * @param {string} props.to - Link destination, defaults to homepage
 * @param {boolean} props.isWhite - Whether to use the white logo variant
 * @param {string} props.className - Additional CSS classes
 * @param {number} props.height - Height of the logo in pixels
 * @param {boolean} props.withText - Whether to show the "ONEPOINT" text next to logo
 * @param {boolean} props.textWhite - Whether the text should be white (for dark backgrounds)
 * @param {Function} props.onClick - Optional click handler
 */
const Logo = ({ 
  to = "/", 
  isWhite = false, 
  className = "", 
  height = 36, 
  withText = false, 
  textWhite = false,
  onClick
}) => {
  // Select the appropriate logo based on the isWhite prop
  const logoSrc = isWhite ? whiteLogo : coloredLogo;
    return (
    <Link to={to} className={`flex items-center gap-2 ${className}`} onClick={onClick}>
      <img 
        src={logoSrc} 
        alt="OnePoint Industrial" 
        className="h-auto transition-all duration-300"
        style={{ height: `${height}px` }} 
      />
      
      {withText && (
        <span className={`font-bold text-lg ${textWhite ? 'text-white' : 'text-gray-800'} transition-colors duration-500`}>
          ONEPOINT
        </span>
      )}
    </Link>
  );
};

export default Logo;
